/** The hub's empty and loading states (spec §6), as pocket statements. */
import { Button, Icons, PocketStatement } from "@/components/ui";
import { useT } from "@/i18n";
import { panelsSearchMessages } from "@/i18n/messages/panels-search";
import type { HubEmpty } from "./hub-types";

export function HubLoading() {
  const t = useT(panelsSearchMessages);
  return (
    <div className="grid place-items-center py-6" data-testid="hub-loading">
      <Icons.Spinner
        className="h-5 w-5 animate-spin text-muted"
        aria-label={t("loading")}
      />
    </div>
  );
}

export function SearchResultsStatus({
  empty,
  onLookInAllProjects,
}: {
  empty: HubEmpty;
  onLookInAllProjects: () => void;
}) {
  const t = useT(panelsSearchMessages);
  switch (empty.kind) {
    case "no-match":
      return (
        <PocketStatement
          size="empty"
          title={t("noMatch", { query: empty.query })}
          line={
            empty.projectName
              ? t("onlyLookingIn", { project: empty.projectName })
              : t("tryOtherWords")
          }
          action={
            empty.projectName ? (
              <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={onLookInAllProjects}
                data-testid="hub-look-in-all-projects"
              >
                {t("lookInAllProjects")}
              </Button>
            ) : undefined
          }
          testId="hub-empty-no-match"
        />
      );
    case "caught-up":
      return (
        <PocketStatement
          size="empty"
          title={t("caughtUp")}
          line={t("caughtUpLine")}
          testId="hub-empty-caught-up"
        />
      );
    case "nothing-yet":
      return (
        <PocketStatement
          size="empty"
          title={t("nothingYet")}
          testId="hub-empty-nothing-yet"
        />
      );
    case "search-memory":
      return (
        <PocketStatement
          size="empty"
          title={t("typeToSearchMemory")}
          testId="hub-empty-search-memory"
        />
      );
    case "error":
      return (
        <PocketStatement
          size="empty"
          title={empty.message}
          testId="hub-empty-error"
        />
      );
  }
}
